import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import TooltippedText from '../tooltip/TooltippedText/TooltippedText.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationDialog',
  props: {
    showDialog: { type: Boolean },
    icon: { default: '$icon_delete' },
    iconColor: { default: 'negative' }
  },
  emits: ["closeDialog"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'closeDialog'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { showDialog?: boolean, icon: string, iconColor: string };

const cardTitleText = ref<HTMLElement | null>(null);
const displayTooltip = ref(false);
const titleSlotContent = ref('');

const setTitleSlotContent = () => {
  const cardTitleTextValue = cardTitleText.value;
  if (cardTitleTextValue) {
    if (
      cardTitleTextValue.scrollHeight > cardTitleTextValue.clientHeight ||
      cardTitleTextValue.scrollWidth > cardTitleTextValue.clientWidth
    ) {
      displayTooltip.value = true;
    } else displayTooltip.value = false;
    titleSlotContent.value = cardTitleTextValue.textContent?.trim() || '';
  }
};

onMounted(setTitleSlotContent);





const iconBackground = computed(() => {
  return { 'background-color': `var(--v-${props.iconColor}Clear-base)` };
});
const showDialogViewModel = computed({
  get: () => props.showDialog,
  set: (value) => {
    if (!value) emit('closeDialog');
  },
});

return { __sfc: true,cardTitleText, displayTooltip, titleSlotContent, setTitleSlotContent, props, emit, iconBackground, showDialogViewModel, TooltippedText }
}

})